"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Helpers = (function () {
    function Helpers() {
    }
    Helpers.prototype.setRequestAnimationFrame = function () {
        var myRequestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 10);
            };
        window.requestAnimationFrame = myRequestAnimationFrame;
    };
    return Helpers;
}());
exports.default = Helpers;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/helpers.ts
// module id = 2010
// module chunks = 4